import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, UrlSegment } from '@angular/router';
import { TokenUserInfo } from './shared/services/tokenUserInfo.service';

// export function checkUrl(url: UrlSegment[]) {
//   return url.length === 1 && url[0].path.includes('/foru/offer-details') ? ({ consumed: url }) : null;
// }
const _window: any = window
const displayableBannerName = _window['AB']['userInfo']['displayableBanner'];
const routes: Routes = [
  {
    path: 'foru-guest.html',
    loadChildren: () => import('./components/foru-guest-page/foru-guest-page.module').then(module => module.ForuGuestPageModule),
    // title: `${displayableBannerName} for U`
  },
  // {
  //   matcher: (url: UrlSegment[]) => url.length > 0 && url.findIndex((path: any) => path.path.includes('foru-guest')) >= 0 ? ({ consumed: url }) : null,
  //   loadChildren: () => import('./components/foru-guest-page/foru-guest-page.module').then(module => module.ForuGuestPageModule),
  //   resolve: {
  //     tokenObject: TokenUserInfo
  //   },
  //   // title: `${displayableBannerName} for U`
  // },
  {
    path: 'loyalty/coupons-deals',
    loadChildren: () => import('./components/gallery-page/gallery-page.module').then(module => module.GalleryPageModule),
    resolve: {
      tokenObject: TokenUserInfo
    },
    // title: `Deals+ | ${displayableBannerName}`
  },
  {
    path: 'loyalty/coupons-deals.html',
    loadChildren: () => import('./components/gallery-page/gallery-page.module').then(module => module.GalleryPageModule),
    resolve: {
      tokenObject: TokenUserInfo
    },
    // title: `Deals+ | ${displayableBannerName}`
  },
  {
    path: 'foru/coupons-deals.html',
    loadChildren: () => import('./components/gallery-page/gallery-page.module').then(module => module.GalleryPageModule),
    resolve: {
      tokenObject: TokenUserInfo 
    },
    // title: `Deals+ | ${displayableBannerName}`
  },
  // {
  //   // path: 'foru/offer-details',
  //   matcher: (url: UrlSegment[]) => url.length > 0 && url.findIndex((path: any) => path.path.includes('coupons-deals')) >= 0 ? ({ consumed: url }) : null,
  //   loadChildren: () => import('./components/gallery-page/gallery-page.module').then(module => module.GalleryPageModule),
  //   resolve: {
  //     tokenObject: TokenUserInfo
  //   },
  //   // title: `Deals+ | ${displayableBannerName}`
  // },
  // {
  //   matcher: (url: UrlSegment[]) => url.length > 0 && url.findIndex((path: any) => path.path.includes('deals')) >= 0 ? ({ consumed: url }) : null,
  //   loadChildren: () => import('./components/gallery-page/gallery-page.module').then(module => module.GalleryPageModule),
  //   resolve: {
  //     tokenObject: TokenUserInfo
  //   },
  //   // title: `Deals+ | ${displayableBannerName}`
  // },

  {
    path: 'loyalty/discovery',
    loadChildren: () => import('./components/discovery-page/discovery-page.module').then(module => module.DiscoveryPageModule),
      resolve: {
      tokenObject: TokenUserInfo 
    },
     title: `Discovery | ${displayableBannerName}`
  },
  {
    path: 'loyalty/discovery.html',
    loadChildren: () => import('./components/discovery-page/discovery-page.module').then(module => module.DiscoveryPageModule),
      resolve: {
      tokenObject: TokenUserInfo 
    },
     title: `Discovery | ${displayableBannerName}`
  },
  {
    path: 'loyalty/mylist',
    loadChildren: () => import('./components/my-list-page/my-list-page.module').then(module => module.MyListPageModule),
    resolve: {
      tokenObject: TokenUserInfo
    },
    // title: `My List | ${displayableBannerName}`
  },
  {
    path: 'loyalty/mylist.html',
    loadChildren: () => import('./components/my-list-page/my-list-page.module').then(module => module.MyListPageModule),
    resolve: {
      tokenObject: TokenUserInfo
    },
    // title: `My List | ${displayableBannerName}`
  },
  // {
  //   path: 'mylist.html',
  //   loadChildren: () => import('./components/my-list-page/my-list-page.module').then(module => module.MyListPageModule),
  //   resolve: {
  //     tokenObject: TokenUserInfo
  //   },
  //   // title: `My List | ${displayableBannerName}`
  // },
  // {
  //   matcher: (url: UrlSegment[]) => url.length > 0 && url.findIndex((path: any) => path.path.includes('mylist')) >= 0 ? ({ consumed: url }) : null,
  //   loadChildren: () => import('./components/my-list-page/my-list-page.module').then(module => module.MyListPageModule),
  //   resolve: {
  //     tokenObject: TokenUserInfo
  //   },
  //   // title: `My List | ${displayableBannerName}`
  // },
  {
    matcher: (url: UrlSegment[]) => url.length > 0 && url.findIndex((path: any) => path.path.includes('loyalty')) >= 0 && url.findIndex((path: any) => path.path.includes('offer-details')) >= 0 ? ({ consumed: url }) : null,
    loadChildren: () => import('./components/offer-details-page/offer-details-page.module').then(module => module.OfferDetailsPageModule),
    resolve: {
      tokenObject: TokenUserInfo
    },
    // title: `Offer Details | ${displayableBannerName}`
  },
  {
    path: 'bin/safeway/sso',
    loadChildren: () => import('./components/gallery-page/gallery-page.module').then(module => module.GalleryPageModule),
    resolve: {
      tokenObject: TokenUserInfo
    },
  },
  {
    path: 'loyalty/foru-guest.html',
    loadChildren: () => import('./components/membership-benefits-page/membership-benefits.module').then(module => module.MembershipBenefitsModule),
  },
  {
    path: 'loyalty/foru-guest',
    loadChildren: () => import('./components/membership-benefits-page/membership-benefits.module').then(module => module.MembershipBenefitsModule),
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, 
    {
      scrollPositionRestoration: 'enabled', 
      preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
